export default {
    url: '/add',
    template: '<manage-settings-licences-add licence="vm.licence"><manage-settings-licences-add/>',
    controller (LicenceResource) {
        this.licence = new LicenceResource();
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/manage/settings/licences/add/index.js